import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { getItemUrl, isNotNull } from "sprout-lib";
import { sortLabels } from "@sprout/client-lib/dist/labels_next";
import useAlterLabelsForItems from "@sprout/client-components/dist/Dialog_next/LabelsDialog/graphql/mutations/useAlterLabelsForItems";
import PostPageHeader from "../PostPageHeader";
import PostPageBreadcrumbs from "../PostPageBreadcrumbs";
import PostPageCard from "../PostPageCard";
import { usePostPageNoteEditor, PostPageNoteEditor } from "../PostPageEditors";
import PostPageComments from "../PostPageComments";
import PostPagePageBanner from "../PostPagePageBanner";
import { PostPagePost } from "../PostPagePost";
import PostPageLabels from "../PostPageLabels";
import PostPageAssignees from "../PostPageAssignees";
import usePostPageAssignAndLabelAction from "../usePostPageAssignAndLabelAction";
import usePostPageSharedGlobalHandlers from "../usePostPageSharedGlobalHandlers";
import PostPageWhenOrDeadline from "../PostPageWhenOrDeadline";
import PostPageHeaderFocusWhenButton from "../PostPageHeaderFocusWhenButton";
import PostPageHeaderStarredButton from "../PostPageHeaderStarredButton";
const PostPageViewsTodoMain = (props)=>{
    const { todo  } = props;
    const { id , rootTopicOrSelf , rootPost , breadcrumbsList , note , commentCount , comments , appliedLabels , assignments , when , whenReminder , deadline , currentUserHasStarred , userPreferences ,  } = todo;
    const rootOwner = rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.owner;
    const rootURL = getItemUrl(rootTopicOrSelf, rootOwner);
    const { renderNote , setIsNoteBlank  } = usePostPageNoteEditor({
        note: !!note
    });
    const focusWhen = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.focusWhen;
    /**
   * TODO: Logic for both `assignments` and `labels` is identical to `PostPageViewsPost`
   * Find a way to make it reusable
   */ const labels = useMemo(()=>{
        const appliedLabelsThatExists = !appliedLabels ? [] : appliedLabels.filter(isNotNull);
        return sortLabels(appliedLabelsThatExists);
    }, [
        appliedLabels
    ]);
    const selectedItems = useMemo(()=>[
            todo
        ], [
        todo
    ]);
    const alterLabelsForItems = useAlterLabelsForItems(labels, selectedItems);
    const assignees = useMemo(()=>{
        return assignments.map(({ assignee  })=>assignee).filter(isNotNull);
    }, [
        assignments
    ]);
    const { elements  } = usePostPageAssignAndLabelAction(todo);
    const { elements: elements2  } = usePostPageSharedGlobalHandlers(todo);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            elements,
            elements2,
            (rootPost === null || rootPost === void 0 ? void 0 : rootPost.breadcrumbsList) && rootOwner && /*#__PURE__*/ _jsx(PostPageHeader, {
                breadcrumbsList: rootPost === null || rootPost === void 0 ? void 0 : rootPost.breadcrumbsList,
                owner: rootOwner,
                appendMeta: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        currentUserHasStarred && /*#__PURE__*/ _jsx(PostPageHeaderStarredButton, {
                            item: todo
                        }),
                        focusWhen && /*#__PURE__*/ _jsx(PostPageHeaderFocusWhenButton, {
                            postId: id,
                            focusWhen: focusWhen
                        }),
                        (when || whenReminder || deadline) && /*#__PURE__*/ _jsx(PostPageWhenOrDeadline, {
                            item: todo
                        }),
                        appliedLabels && appliedLabels.length !== 0 && /*#__PURE__*/ _jsx(PostPageLabels, {
                            rootURL: rootURL,
                            labels: labels,
                            alterLabelsForItems: alterLabelsForItems
                        }),
                        assignees.length > 0 && /*#__PURE__*/ _jsx(PostPageAssignees, {
                            assignees: assignees
                        })
                    ]
                }),
                append: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        breadcrumbsList ? /*#__PURE__*/ _jsx(PostPageBreadcrumbs, {
                            breadcrumbsList: breadcrumbsList
                        }) : undefined,
                        /*#__PURE__*/ _jsx(PostPagePost, {
                            post: todo
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(PostPagePageBanner, {
                item: todo,
                negativeMargins: renderNote
            }),
            renderNote && /*#__PURE__*/ _jsx(PostPageCard, {
                children: /*#__PURE__*/ _jsx(PostPageNoteEditor, {
                    setIsNoteBlank: setIsNoteBlank,
                    itemId: id,
                    note: note
                })
            }),
            /*#__PURE__*/ _jsx(PostPageComments, {
                item: todo,
                commentCount: commentCount,
                comments: comments.nodes
            })
        ]
    });
};
export default PostPageViewsTodoMain;
